// Esqueletos de carga: la forma de lo que va a aparecer (tarjetas, filas o texto) con
// un brillo que pasa, en lugar de un "Cargando…". Los lectores de pantalla oyen el texto.

const Barra = ({ className = "" }) => <span className={`esqueleto block rounded-full ${className}`} />;

function TarjetaEsqueleto() {
  return (
    <div className="panel p-5">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 space-y-2.5">
          <Barra className="h-4 w-2/3" />
          <Barra className="h-3 w-1/2" />
        </div>
        <Barra className="h-5 w-16" />
      </div>
      <div className="mt-5 space-y-2">
        <Barra className="h-3 w-5/6" />
        <Barra className="h-3 w-3/5" />
      </div>
      <div className="mt-5 flex gap-2">
        <Barra className="h-8 flex-1" />
        <Barra className="h-8 flex-1" />
      </div>
    </div>
  );
}

function FilaEsqueleto() {
  return (
    <div className="panel-interior flex items-center gap-4 p-4">
      <span className="esqueleto h-10 w-10 shrink-0 rounded-full" />
      <div className="flex-1 space-y-2">
        <Barra className="h-3.5 w-1/2" />
        <Barra className="h-3 w-1/3" />
      </div>
      <Barra className="hidden h-7 w-20 sm:block" />
    </div>
  );
}

// tipo: "tarjetas" (cuadrícula), "lista" (filas) o "texto" (un bloque corto).
function Esqueleto({ tipo = "lista", cantidad, texto = "Cargando…", className = "" }) {
  const n = cantidad ?? (tipo === "tarjetas" ? 6 : 4);
  return (
    <div role="status" aria-live="polite" className={className}>
      <span className="sr-only">{texto}</span>
      {tipo === "tarjetas" && (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3" aria-hidden="true">
          {Array.from({ length: n }, (_, i) => <TarjetaEsqueleto key={i} />)}
        </div>
      )}
      {tipo === "lista" && (
        <div className="space-y-3" aria-hidden="true">
          {Array.from({ length: n }, (_, i) => <FilaEsqueleto key={i} />)}
        </div>
      )}
      {tipo === "texto" && (
        <div className="space-y-2.5" aria-hidden="true">
          <Barra className="h-4 w-1/3" />
          <Barra className="h-3 w-2/3" />
          <Barra className="h-3 w-1/2" />
        </div>
      )}
    </div>
  );
}

export default Esqueleto;
